module.exports = __webpack_public_path__ + "media/svg/mycorner-gris-ff4200fb.svg";